'use client';

import { usePathname } from 'next/navigation';
import { useSyncExternalStore, useState } from 'react';

import { AB_CHOICE_COOKIE, AB_CHOICE_PARAM } from '@/shared/ab/rules';

const DISMISSED = 'ab:back-to-new-dismissed';
const subscribe = () => () => {};

const readDismissed = () => {
  try {
    return localStorage.getItem(DISMISSED) === '1';
  } catch {
    return false;
  }
};

const cameBack = () =>
  document.cookie
    .split(';')
    .some((part) => part.trim() === `${AB_CHOICE_COOKIE}=old`);

/**
 * Кто вернулся с новой версии: одна строка, что можно передумать. Плавающая: вёрстку не
 * сдвигает. Обычная ссылка, а не next/link: выбор запоминает middleware на загрузке страницы.
 */
export function BackToNewSite() {
  const pathname = usePathname();
  const returned = useSyncExternalStore(subscribe, cameBack, () => false);
  const [dismissed, setDismissed] = useState(false);
  if (!returned || dismissed || readDismissed()) return null;
  return (
    <div className="fixed inset-x-3 bottom-24 z-30 flex items-center gap-3 rounded-2xl border border-default-200 bg-white p-3 text-small shadow-lg md:inset-x-auto md:bottom-6 md:left-6 md:max-w-sm">
      <p className="min-w-0 flex-1">
        Вы на старом сайте.{' '}
        <a
          className="underline underline-offset-4"
          href={`${pathname}?${AB_CHOICE_PARAM}=new`}
        >
          Открыть новую версию
        </a>
      </p>
      <button
        aria-label="Закрыть"
        className="flex size-8 shrink-0 items-center justify-center rounded-full text-default-500 hover:bg-default-100"
        onClick={() => {
          try {
            localStorage.setItem(DISMISSED, '1');
          } catch {
            // Браузер не даёт хранить — строка вернётся на следующей странице
          }
          setDismissed(true);
        }}
        type="button"
      >
        ×
      </button>
    </div>
  );
}
